import { FILTER_TYPE_TEXT, FILTER_TYPE_MULTISELECT, FILTER_TYPE_DATETIME } from "@/store/system/helpers";
import store from "@/store";

export function getBlankCriteria() {
  return {
    userId: null,
    fromDate: null,
    toDate: null,
    actions: []
  };
}

export function getSearchFilters(actionsFilter) {
  const filters = [];
  filters.push({ text: "Email", width: 6, value: "userEmail", type: FILTER_TYPE_TEXT });
  filters.push({ text: "Description", width: 6, value: "   ", type: FILTER_TYPE_TEXT });
  filters.push({ text: "From", width: 6, value: "fromDate", type: FILTER_TYPE_DATETIME });
  filters.push({ text: "To", width: 6, value: "toDate", type: FILTER_TYPE_DATETIME });
  return filters;
}

export function addFiltersToCriteria(criteria, state) {
  criteria.userId = state.listing.userId;
  return criteria;
}
